import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'rx-drag-preview-multiple',
  templateUrl: './rx-drag-preview-multiple.component.html',
  styleUrls: ['./rx-drag-preview-multiple.component.scss'],
  imports: [CommonModule, RxIconModule],
})
export class RxDragPreviewMultipleComponent implements OnInit {
  @Input() count: number;
  constructor() {}

  ngOnInit() {}
}
